<template>

    <div class="section_block_home mobile_div" v-if="is_load">
      <div class="col-12 row second_section mt-2 mb-4 ">

        <div class="col-lg-12 row">

          <div class="row col-lg-6">


            <input type="text" class="m-2 form-control" placeholder="Введите для поиска"  v-model="searchfields['q']"/>

          </div>
          <div class="row col-lg-6">
            <select class="m-2 form-control"  v-model="searchfields['_type']">
              <option value="null">Выберите тип</option>
              <option value="projects">Проекты</option>
              <option value="tasks">Задачи</option>
              <option value="all">Проекты и задачи</option>

            </select>
          </div>
        </div>

        <div  class="col-lg-12 row"    v-if="fields   && fields.length>0">
          <div class="row col-lg-6  form-group"  v-for="field in fields"   :key="field.last_id">
            <div class="col-md-6">
              <label for="exampleCategory">{{ field.title}} </label>
            </div>
            <div class="col-md-6">
              <select  id="exampleCategory" v-if="field.type=='select' || field.type=='selectinsert'" v-model="searchfields[field.name]"

                  class="form-control">
                <option value="null"></option>
                <option v-for="value in field.values" :value="value.last_id" :key="value.last_id">
                  {{ value[field.key_title] }}
                </option>

              </select>

              <select  id="exampleCategory" v-if="field.type=='selectteam'" v-model="searchfields[field.name]"

                  class="form-control">
                <option value="null"></option>
                <option v-for="user_team in field.users" :value="user_team.last_id" :key="user_team.last_id">
                  {{ user_team.name }}
                </option>

              </select>
              <input class="form-control" type="number" v-if="field.type=='number'" v-model="searchfields[field.name]"/>
              <input class="form-control" type="text" v-if="field.type=='stroka'" v-model="searchfields[field.name]"/>
            </div>






          </div>

        </div>
        <div class="form-group">
          <button class="btn" @click="searchFilter()">Найти</button>

        </div>


      </div>


      <div class="row" v-if="stages.length>0">

        <kanban-board  @update-block="updateBlock" :stages="stages" :blocks="blocks"> <div v-for="stage in stages" :slot="stage" :key="stage" >
          <h2>{{ stage }}</h2>
        </div>

          <div class="card lead_mini" style="" v-for="block in blocks" :slot="block.id" :key="block.id" >

            <div class="card-body lead_info overflow-hidden">

              <badge pill type="warning" @click="openProject(block.project.main_project.last_id)" v-if="block.project.main_project && block.project.main_project.name_project && block.project.main_project.name_project.length>0">[{{ block.project.main_project.name_project}}]
              </badge><br>
              <p class="lead" @click="openProject(block.id)"  v-if="block.project.name_project && block.project.name_project.length>0">{{ block.project.name_project}}</p>

              <div class="row">

                <div class="col-8">

                  <div v-if="fields.length>0" v-for="field in fields"  :key="block.id">
                    <p v-if='block.project.custom_fields && block.project.custom_fields[field.name] && !(block.project.custom_fields[field.name+"_title"])'><badge type="success">{{ field.title}}</badge> {{ block.project.custom_fields[field.name] }}</p>
                    <p v-if='block.project.custom_fields  && (block.project.custom_fields[field.name+"_title"])'><badge type="success">{{ field.title}}</badge> {{ block.project.custom_fields[field.name+'_title'] }}</p>

                  </div>


                </div>
                <div class="col-4">
                  <img class="img img-thumbnail" :src="image_url+block.project.developer.avatar"/>



                </div>
              </div>

              <div class="row mt-2">
                <div class="col-4">
                  <div class="mt-2">
                    <router-link tag="a"  :to="{name: 'project',params:{id:block.project.last_id}}">
                      <badge type="default">#{{block.project.last_id}}</badge>
                    </router-link>

                  </div>
                </div>
                <div class="col-8">
                  <div>
                    <router-link tag="a" class="btn side4"  :to="{name: 'project',params:{id:block.project.last_id}}">Открыть</router-link>

                  </div>
                </div>
              </div>



            </div>

          </div>
        </kanban-board>
      </div>
    </div>



</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";

import vueKanban from 'vue-kanban';
import itemTemplate from '@/components/itemTemplate.vue';
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load":false,
      stages: [],
      current_funnel:null,
      statuses:[],
      'fields':{},
      'form':{
        'fields':{},
      },
      funnel:null,
      blocks: [

      ],
      'searchfields':{},
      "funnels": {},
      item: {},
      items: [

      ],
      itemTemplate,
      'image_url':'',


    }
  },

  mounted: function () {

    var app = this;
    app.image_url=Vue.config.IMAGE_URL;
    let id = app.$route.params.id;
    app.current_funnel=id;

    Api.loadProjectFields({},function(data){
      app.is_load=true;
      var loaded_vars=data.get_vars;
      var new_vars={};


      Object.keys(loaded_vars).map(function(objectKey, index) {
        var item = loaded_vars[objectKey];
        if(item && item!="null"){
          new_vars[objectKey]=item;
        }else{
          new_vars[objectKey]="";
        }
      });



      app.fields=data.fields;
      app.searchfields=new_vars;

      if(data.statuses.length>0){
        app.statuses=data.statuses;
        var statuses=data.statuses;
        statuses.forEach((element) => {
          app.stages.push(element.title);
        })
        statuses.forEach((element) => {

          if(element.projects && element.projects.length>0){
            var projects=element.projects;


            projects.forEach((project) => {

              var new_arr={
                id: project.last_id,
                status: element.title,
                title: project.name_project,
                project:project,
              }
              app.blocks.push(new_arr);
            })
          }
        })

      }
    })





  },
  methods: {
    callModelEditLead(lead){
      var app=this;
      var params = {
        "lead_id": lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    updateBlock(id, status) {
      var app=this;

      var statuses=app.statuses;
      var new_status=null;
      statuses.forEach((element) => {
        if(element.title==status){
          new_status=element;
        }

      })
      if(new_status!=null){
        var app=this;
        var lead_id=id;

        var  json={

          "status_id":new_status.last_id,

        }

        Api.setNewStatus(new_status.last_id, id, function (data) {


          if(data.type=="error"){
            alert(data.message);
          }

        });
      }
    return false;

      //this.blocks.find(b => b.id === Number(id)).status = status;
    },
    searchFilter(){
      var app=this;
      var filter=this.searchfields;
      app.is_load=false;



      Api.loadSaveProjectFields(filter,function(data){


        var loaded_vars=data.get_vars;
        var new_vars={};


        Object.keys(loaded_vars).map(function(objectKey, index) {
          var item = loaded_vars[objectKey];
          if(item && item!="null"){
            new_vars[objectKey]=item;
          }else{
            new_vars[objectKey]="";
          }
        });

        app.is_load=true;
        app.stages.length=0;

        app.stages=[];
        app.blocks.length=0;
        app.blocks=[];
        app.statuses.length=0;
        app.statuses=[];
   //     while( app.stages.length > 0) { app.stages.length.pop();}
  //      while( app.blocks.length > 0) { app.blocks.length.pop();}
    //    while( app.statuses.length > 0) { app.statuses.length.pop();}


        app.fields=data.fields;

        app.searchfields=new_vars;


        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;

              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }
          })

        }
      })
    },
    openProject(lead_id){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: lead_id, "rand": Math.random()}});
      window.open(routeData.href, '_blank');
    },
    itemSelected (item) {
      this.item = item;
      var app=this;
      app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
    },
    setLabel (item) {
      return item.name;
    },
    inputChange (text) {
      var app=this;
      // your search method
      app.items=[];
      Api.searchLead(text,function(data){
        if(data.leads.length>0){
          var leads=data.leads;

          leads.forEach((element) => {
            var name="";
            if(element.lead_data.name){
              name=name+" "+element.lead_data.name;
            }
            if(element.lead_data.phone){
              name=name+" "+element.lead_data.phone;
            }
            if(element.lead_data.email){
              name=name+" "+element.lead_data.email;
            }
            name=name+" "+element.funnel.title+"/"+element.status.title;
            var new_element={id:element.id,name:name};
            app.items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    callModalAddLead() {
      var app=this;
      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление лида",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },


  },
  components: {Modal,LoadingBlock}
};
</script>
